import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'app-thought-record-question-checkbox-add-element',
    templateUrl: 'add-element-checkbox.modal.html',
    styleUrls: ['add-element-checkbox.modal.scss']
})
export class AddElementCheckboxModal {

    @Input() options: { value: string, label: string }[];

    constructor(private modalController: ModalController) {
    }

    dismiss() {
        this.modalController.dismiss();
    }

    selectOption(option: any) {
        this.modalController.dismiss(option);
    }
}
